import React, { useState, useEffect } from "react";
import Loader from "../../components/Loader/Loader.js";
import { InvoicesList } from "../../components/Invoices/InvoicesList/InvoicesList";
import { useAuth } from "../../hooks";
import { BACKEND_URL } from "../../config/config";
import axios from "axios";
import { useNotification } from "../../context/NotificationContext.js";

export function Invoices() {
  const [isLoading, setIsLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [reload, setReload] = useState(false);

  const { user } = useAuth();
  const { notification } = useNotification();

  const getData = async () => {
    setIsLoading(true);
    const url = `${BACKEND_URL}/customers/getInvoicesByCustomerId?id=${user._id}`;

    const dataInvoices = await axios.get(url).catch((err) => console.log(err));

    if (dataInvoices?.data) {
      const payload = dataInvoices?.data?.invoices;

      setInvoices(payload);

      setIsLoading(false);
    } else {
      setIsLoading(false);
      console.log("No  data retrieved");
    }
  };

  //ORDENARLO POR MONTO DESCENDENTE

  //   const getData = async () => {
  //   setIsLoading(true);
  //   const url = `${BACKEND_URL}/customers/getInvoicesByCustomerId?id=${user._id}`;

  //   try {
  //     const { data } = await axios.get(url);
  //     const items = Array.isArray(data?.invoices) ? data.invoices : [];

  //     // Ordenar por monto (desc). Cambiá 'totalAmountDue' si tu campo es otro.
  //     const sorted = items
  //       .map(it => ({
  //         ...it,
  //         __amt: Number(it?.totalAmountDue ?? it?.amount ?? 0),
  //       }))
  //       .sort((a, b) => b.__amt - a.__amt)
  //       .map(({ __amt, ...rest }) => rest);

  //     setInvoices(sorted);
  //   } catch (err) {
  //     console.error("Error fetching invoices:", err);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, reload]);

  // Refreshes this list when a push notification arrives while the tab is
  // open, same signal MenuTop/Notifications already use for the unread
  // badge/list.
  useEffect(() => {
    if (notification) {
      setReload((r) => !r);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification]);

  return (
    <div
      style={{ display: "flex", flexDirection: "column", paddingTop: "1rem" }}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <InvoicesList invoices={invoices} title="My Invoices" pageSize={20} />
      )}
    </div>
  );
}
